import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Button, FormControl, Form, Container } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { FaCalendarAlt, FaTrashAlt } from 'react-icons/fa'
import DTODiaFestivo from '../CatVacaciones/DTO/DTODiaFestivo'
import CatVacaciones from '../../../Services/Catalogos/CatVacaciones'

export default function CatDiasFestivos() {
  const [data, setData] = useState<DTODiaFestivo[]>([])
  const [fecha, setFecha] = useState('')
  const [descripcion, setDescripcion] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [selectedYear, setSelectedYear] = useState<string>('') 

  const columns = [
    {
      name: 'Fecha',
      selector: (row: DTODiaFestivo) => row.fecha,
      sortable: true,
      format: (row: DTODiaFestivo) => new Date(row.fecha).toLocaleDateString('es-MX', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' }),
    },
    {
      name: 'Descripción',
      selector: (row: DTODiaFestivo) => row.descripcion,
      sortable: true
    },
    {
      name: 'Acciones',
      cell: (row: DTODiaFestivo) => (
        <Button 
          variant="danger" 
          size="sm" 
          onClick={() => handleEliminar(row.fecha)} 
          disabled={loading}
        >
          <FaTrashAlt />
        </Button>
      )
    }
  ]

  const cargarDatos = () => {
    setLoading(true)
    CatVacaciones.GetDiaFestivos()
      .then(response => {
        setData(response.data)
        setLoading(false)
      })
      .catch(error => {
        console.error('Error al cargar los días festivos:', error)
        setError('No se pudieron cargar los días festivos.')
        setLoading(false)
      })
  }

  const handleGuardar = () => {
    if (!fecha || !descripcion) {
      setError('Por favor complete todos los campos.')
      return
    }

    const diaFestivo: DTODiaFestivo = {
      fecha: fecha,
      descripcion: descripcion
    }

    setLoading(true)
    setError(null)

    CatVacaciones.InsertUpdateDias(diaFestivo)
      .then(response => {
        console.log('Día festivo guardado o actualizado correctamente', response.data)
        cargarDatos() 
        setFecha('') 
        setDescripcion('') 
        setLoading(false)
      })
      .catch(error => {
        console.error('Error al guardar o actualizar el día festivo:', error)
        setError('Hubo un error al guardar o actualizar el día festivo.')
        setLoading(false)
      })
  }

  const handleEliminar = (fecha: string) => {
    setLoading(true)
    setError(null)

    CatVacaciones.DeleteDiafestivo(fecha)
      .then(response => {
        console.log('Día festivo eliminado correctamente', response.data)
        cargarDatos() 
        setLoading(false)
      })
      .catch(error => {
        console.error('Error al eliminar el día festivo:', error)
        setError('Hubo un error al eliminar el día festivo.')
        setLoading(false)
      })
  }

  useEffect(() => {
    cargarDatos() 
  }, [])

  const groupedData = data.reduce((groups: any, item: DTODiaFestivo) => {
    const year = new Date(item.fecha).getFullYear();
    if (!groups[year]) {
      groups[year] = [];
    }
    groups[year].push(item);
    return groups;
  }, {});

  const years = Object.keys(groupedData);

  return (
    <Container className="mt-4">
      <Card className="shadow-lg rounded p-3" style={{ backgroundColor: '#ffffff' }}>
        <Card.Body>
          <Row className="mb-3">
            <Col xs={5}>
              <Form.Label>Fecha</Form.Label>
              <FormControl
                type="date"
                value={fecha}
                onChange={e => setFecha(e.target.value)}
              />
            </Col>
            <Col xs={5}>
              <Form.Label>Descripción</Form.Label>
              <FormControl
                type="text"
                value={descripcion}
                onChange={e => setDescripcion(e.target.value)}
              />
            </Col>
            <Col xs={2} className="d-flex align-items-end">
              <Button variant="success" onClick={handleGuardar} disabled={loading} className="w-100">
                {loading ? 'Guardando...' : 'Guardar'}
              </Button>
            </Col>
          </Row>

          {error && <div className="alert alert-danger">{error}</div>}

          <Row className="mt-3">
            {years.map(year => (
              <Col md={4} xs={12} key={year} className="mb-3">
                <Card
                  className="year-card text-center shadow-lg rounded"
                  style={{
                    backgroundColor: '#A3D8F4',
                    border: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    transform: 'scale(1)',
                  }}
                  onClick={() => setSelectedYear(year)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#72AEE6';
                    e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#A3D8F4';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <Card.Body>
                    <FaCalendarAlt className="mb-2 text-white" size={30} />
                    <h5 className="text-white">{year}</h5>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <div>
            {selectedYear && groupedData[selectedYear] && (
              <DataTable
                noHeader
                pagination
                columns={columns}
                data={groupedData[selectedYear]}
                highlightOnHover
                striped
                dense
                customStyles={{
                  table: {
                    style: {
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    }
                  },
                  header: {
                    style: {
                      backgroundColor: '#f8f9fa',
                      color: '#007BFF',
                      fontWeight: 'bold',
                    }
                  },
                  rows: {
                    style: {
                      borderTop: '1px solid #ddd',
                    },
                    highlightOnHoverStyle: {
                      backgroundColor: '#E0F7FA',
                    }
                  },
                }}
              />
            )}
          </div>
        </Card.Body>
      </Card>
    </Container>
  )
}

